import React, { Component } from "react";
class Vysledek extends Component {
  render() {
    //console.log("Zobrazuji vysledek");
    return (
      <React.Fragment>
      <div className="jumbotron">
        <h1 className="display-4">Hotovo</h1>
        <h2>Nalezli jste poklad {this.props.cisloOtazky} - {this.props.nadpis}</h2>
        <p className="lead">Váš čas je {this.props.cas}</p>
      </div>

      <div className="row mt-4">
      <div className="col">
        <button className="btn btn-primary" onClick={(e)=>this.props.onNext(e, 0)}>
          Zpět
        </button>
      </div>
      </div>
    </React.Fragment>
    );
  }
}

export default Vysledek;
